import { render, staticRenderFns } from "./projectmate.vue?vue&type=template&id=00933d5c"
import script from "./projectmate.vue?vue&type=script&lang=js"
export * from "./projectmate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports